import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=4c5561cd"
import script from "./ClienteForm.vue?vue&type=script&lang=js"
export * from "./ClienteForm.vue?vue&type=script&lang=js"
import style0 from "./ClienteForm.vue?vue&type=style&index=0&id=4c5561cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports